import { render, staticRenderFns } from "./ClienteCuentaCorrienteMovimientosDetail.vue?vue&type=template&id=62900a0a&"
import script from "./ClienteCuentaCorrienteMovimientosDetail.vue?vue&type=script&lang=js&"
export * from "./ClienteCuentaCorrienteMovimientosDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VProgressCircular,VSpacer})
